import { useEffect, useState } from 'react';

/**
 * Общая сигнатура функции отправки аналитики при попадании элемента во вьюпорт
 */

/**
 * Хук для отправки события аналитики при попадании элемента во вьюпорт
 *
 * Возвращает ref-коллбек для размещения на нужном элементе
 *
 * При изменении параметров или маунте/анмаунте элемента событие переназначается
 */
const useElementShown = (...args) => {
  const fn = args[0];
  const params = args[1];
  const [element, setElement] = useState(null);
  useEffect(() => {
    if (element) {
      const instance = fn(element, params);
      return () => {
        instance.stopSpying();
      };
    }
    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [element, ...(params ? Object.values(params) : [])]);
  return setElement;
};
export default useElementShown;
//# sourceMappingURL=useElementShown.js.map